import { useEffect, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailLoader, DetailWrapper, O } from "../../../../../features/ui"
import { Operation, useOperationLoaders } from "../../../../operations"
import { Customer, useCustomerLoaders } from "../../../../sales"
import { useDeliveryLoaders } from "../../../loaders/deliveryLoaders"
import { useDeliveryOrderLoaders } from "../../../loaders/deliveryOrderLoaders"
import { Delivery, DeliveryOrder } from "../../../state/types"
import { DeliveryNoteDetail } from "./deliveryNoteDetail"

export const DeliveryNoteDetailLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const delivery = dataType! as Delivery

    const [deliveryOrder, setDeliveryOrder] = useState<O<DeliveryOrder>>()
    const [operation, setOperation] = useState<Operation>()
    const [customer, setCustomer] = useState<O<Customer>>()
    const [ready, setReady] = useState(false)

    const deliveryLoaders = useDeliveryLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const operationLoaders = useOperationLoaders()
    const customerLoaders = useCustomerLoaders()

    const load = async (optimized = true) => {
        if (delivery.orderId) {
            const { loadDeliveryOrder } = deliveryOrderLoaders()
            setDeliveryOrder(await loadDeliveryOrder(delivery.orderId, optimized))
        }
        const { loadOperation } = operationLoaders()
        setOperation(await loadOperation(delivery.table, delivery.operationId))
        if (delivery.customerId) {
            const { loadCustomer } = customerLoaders()
            setCustomer(await loadCustomer(delivery.customerId))
        }
    }

    // Reloads the delivery (the detail reads it from the state) and its order after uploading or annulling
    const refresh = async () => {
        const { loadDelivery } = deliveryLoaders()
        await loadDelivery(delivery.id, false)
        await load(false)
    }

    useEffect(() => {
        load().then(() => setReady(true))
    }, [delivery.id])

    return (
        <DetailWrapper parentPath={RoutePath.DELIVERY_NOTES}>
            <DetailLoader ready={ready}>
                <DeliveryNoteDetail
                    delivery={delivery}
                    deliveryOrder={deliveryOrder}
                    operation={operation!}
                    customer={customer}
                    onRefresh={refresh}
                />
            </DetailLoader>
        </DetailWrapper>
    )
}
